<div class="container-fluid">
  <app-custom-table [data]="this.data" [loading]="this.is_loading" [columns]="this.options"
    [truncationFields]="['job_name']" [removalColumns]="['job_id', 'project_id']" [isParameterView]="true"
    [linkDefinitions]="this.linkDefinitions" [buttonConfig]="this.buttonConfig"
    [inMenuButtonConfig]="this.inMenuButtonConfig" [editRow]="true" [headerTooltips]="headerTooltips"
    [defaultShowingIds]="this.landingJobs" (editRowHandler)="editJob($event)" [template]="testTemplate">
  </app-custom-table>
</div>

<ng-template #testTemplate>
  <div class="template-header">
    <span>
      {{
      selectedGroup?.name
      ? "Currently viewing group: " + selectedGroup.name
      : ""
      }}
    </span>
    <div class="template-header-actions">
      @if (selectedGroup) {
      <button mat-raised-button (click)="showAllJobs()">
        Show all jobs
      </button>
      }
      <button mat-raised-button nz-dropdown [nzDropdownMenu]="groupsMenu" nzTrigger="click" [nzClickHide]="false">
        Job Groups
      </button>
    </div>
  </div>
  <nz-dropdown-menu #groupsMenu="nzDropdownMenu">
    <ul nz-menu class="job-groups-dropdown">
      @if (jobGroups) {
      @for (jobGroup of jobGroups; track jobGroup.id) {
      <li nz-submenu [nzTitle]="jobGroup.name" [nzSelected]="isGroupSelected(jobGroup)" (click)="onGroupClick(jobGroup)"
        [nzClickHide]="false">
        <ul>
          @for (job of jobGroup.jobs; track job.id) {
          <li nz-menu-item [nzDisabled]="true">
            {{ job.job__job_name }}
          </li>
          } @empty {
          <li nz-menu-item [nzDisabled]="true">
            No jobs in this group
          </li>
          }
        </ul>
      </li>
      }
      @empty {
      <li nz-menu-item nzDisabled>No groups available</li>
      }
      } @else {
      <li nz-menu-item nzDisabled>Loading groups...</li>
      }
    </ul>
  </nz-dropdown-menu>
</ng-template>

<nz-modal [(nzVisible)]="isVisible" nzTitle="Create job group" (nzOnCancel)="isVisible = false">
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="creating_group">
      <div class="form-container">
        <p style="margin-bottom: 20px">Job groups for quick access</p>
        <nz-form-item style="padding: 0">
          <nz-form-label nzRequired style="left: 10px">Group Name</nz-form-label>
          <nz-form-control nzErrorTip="Group Name is a required field">
            <input nz-input type="text" [formControl]="this.nameControl" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item style="padding: 0">
          <nz-form-label style="left: 10px">Comment</nz-form-label>
          <nz-form-control>
            <textarea nz-input type="text" [formControl]="this.commentControl"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item style="padding: 0">
          <nz-form-label nzRequired style="left: 10px">Select Jobs</nz-form-label>
          <nz-form-control nzErrorTip="You must select 1 or more jobs">
            <nz-select nzShowSearch nzMode="multiple" style="width: 100%" [formControl]="this.jobsControl"
              [nzLoading]="this.gettingParentJobs">
              @for (job of this.parentJobs; track job.id) {
              <nz-option [nzLabel]="job.job_name" [nzValue]="job.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </nz-spin>
  </ng-container>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="isVisible = false; resetFields()" [disabled]="this.creating_group">
      Cancel
    </button>
    <button nz-button nzType="primary" (click)="createGroup()" [disabled]="this.creating_group">
      Create Group
    </button>
  </div>
</nz-modal>